import React from 'react';
import { Handle } from 'reactflow';
import ExitEditNode from './ExitEditNode';
import MergeExitsEditNode from './MergeExitsEditNode';

const HANDLE_STYLE = {
    background: 'transparent',
    border: 0
};

const OutputEditNode = ({ id, data, connectable }) => {

    return (
        <div style={{display: 'flex', flexDirection: 'column', height: 75, margin: 'auto', cursor: 'pointer'}}>
            <Handle
                type='target'
                position='top'
                id='primary'
                style={HANDLE_STYLE}
                onConnect={(params) => console.log('handle onConnect', params)}
            />
            <ExitEditNode data={data} />
            <MergeExitsEditNode isConnectable={connectable}  data={data} />
            <Handle
                type='source'
                position='bottom'
                style={HANDLE_STYLE}
                isConnectable={connectable}
            />
        </div>
    );
};

export default OutputEditNode;
